import companies from "./companies.component";
import companiesUrls from "./companies.urls";
import CompaniesTransforms from "./companies.transforms";

const companiesModule = angular
  .module("app.components.companies", [])
  .component("companiesPage", companies)
  .service("CompaniesTransforms", CompaniesTransforms)
  .config(companiesUrls);

export default companiesModule;



// WEBPACK FOOTER //
// ./src/pages/companies/companies.module.js